module.exports = __webpack_public_path__ + "static/clearbrain_retargetingX01.dce98f96.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/clearbrain_retargetingX01.png
// module id = 501
// module chunks = 35783957827783